export const environment = {
  production: true,
  prototype: false,
  country: "",
  routes: {
    "pwe": {
      "type": "component",
      "displayName": "pwe",
      "exposedModule": "./Pwe_Routes_External",
      "ngModuleName": "Pwe_Routes_External",
      "remoteEntry": `/modules/pwe/remoteEntry.js`,
      "external": true,
      "routePath": "pwe",
      "title": "Premium Warranty Endorsement (PWE) :: myAIG",
    },
    "capture-a-lead-external": {
      "type": "component",
      "displayName": "capture-a-lead",
      "exposedModule": "./Capture_a_lead_Routes_External",
      "ngModuleName": "Capture_a_lead_Routes_External",
      "remoteEntry": `/modules/capture-a-lead/remoteEntry.js`,
      "external": true,
      "routePath": "capture-a-lead",
      "title": "Capture a Lead :: myAIG",
    },
    "capture-a-lead-internal": {
      "type": "component",
      "displayName": "capture-a-lead",
      "exposedModule": "./Capture_a_lead_Routes_Internal",
      "ngModuleName": "Capture_a_lead_Routes_Internal",
      "remoteEntry": `/modules/capture-a-lead/remoteEntry.js`,
      "internal": true,
      "routePath": "lead-management",
      "title": "Capture a Lead :: myAIG",
    },
    "customer": {
      "type": "component",
      "displayName": "Customer",
      "exposedModule": "./Customer_Routes",
      "ngModuleName": "Customer_Routes",
      "remoteEntry": `/modules/customer/remoteEntry.js`,
      "external": true,
      internal: true,
      "routePath": "customer",
      "title": "Customer :: myAIG",
    },
    "customers": {
      "type": "component",
      "displayName": "Customers",
      "exposedModule": "./Customer_Routes",
      "ngModuleName": "Customer_Routes",
      "remoteEntry": `/modules/customers/remoteEntry.js`,
      "external": true,
      "routePath": "customers",
      "title": "Customers :: myAIG",

    },
    "dashboard": {
      "type": "component",
      "displayName": "Dashboard",
      "exposedModule": "./Dashboard_Routes",
      "ngModuleName": "Dashboard_Routes",
      external: true,
      "remoteEntry": `/modules/dashboard/remoteEntry.js`,
      "routePath": "dashboard",
      "title": "Dashboard :: myAIG",
    },
    "login": {
      "type": "component",
      "displayName": "login",
      "exposedModule": "./Login_Routes",
      "ngModuleName": "Login_Routes",
      "remoteEntry": `/modules/login/remoteEntry.js`,
      "routePath": "",
      "public": true
    },
    "highlights": {
      "type": "component",
      "displayName": "highlights",
      "exposedModule": "./Highlights_Routes",
      "ngModuleName": "Highlights_Routes",
      "remoteEntry": `/modules/highlights/remoteEntry.js`,
      "external": true,
      "routePath": "highlights",
      "title": "Highlights :: myAIG",
    },
    "documents": {
      "type": "component",
      "displayName": "documents",
      "exposedModule": "./Documents_Routes",
      "ngModuleName": "Documents_Routes",
      "remoteEntry": `/modules/documents/remoteEntry.js`,
      "external": true,
      "routePath": "documents",
      "title": "Documents :: myAIG",
    },
    "products": {
      "type": "component",
      "displayName": "products",
      "exposedModule": "./Products_Routes",
      "ngModuleName": "Products_Routes",
      "remoteEntry": `/modules/products/remoteEntry.js`,
      "external": true,
      "routePath": "products",
      "title": "Products :: myAIG",
    },
    "statements": {
      "type": "component",
      "displayName": "Statements",
      "exposedModule": "./Statements_Routes",
      "ngModuleName": "Statements_Routes",
      "remoteEntry": `/modules/statements/remoteEntry.js`,
      "external": true,
      "routePath": "statements",
      "title": "Statements :: myAIG",
    },
    "renewal-notice": {
      "type": "component",
      "displayName": "renewal-notice",
      "exposedModule": "./Renewal_Routes",
      "ngModuleName": "Renewal_Routes",
      "remoteEntry": `/modules/renewal-notice/remoteEntry.js`,
      "external": true,
      "routePath": "renewal-notice",
      "title": "Renewal Notice :: myAIG",
    },
    "marketing-status": {
      "type": "component",
      "displayName": "marketing-status",
      "exposedModule": "./Marketing_Routes",
      "ngModuleName": "Marketing_Routes",
      "remoteEntry": `/modules/marketing-status/remoteEntry.js`,
      "external": true,
      "routePath": "marketing-status",
      "title": "Marketing-status :: myAIG",
    },
    "notification-center": {
      "displayName": "NotificationCenter",
      "exposedModule": "./NotificationsModule",
      "ngModuleName": "NotificationsModule",
      "remoteEntry": `/modules/notification-center/remoteEntry.js`,
      "routePath": "notification-center",
      "internal": true,
      "type": "module",
    },
    "organizations": {
      "displayName": "Organizations",
      "exposedModule": "./OrganizationsModule",
      "ngModuleName": "OrganizationsModule",
      "remoteEntry": `/modules/organizations/remoteEntry.js`,
      "routePath": "organisations",
      "internal": true,
      "type": "module",
    },
    "registration-requests": {
      "displayName": "RegistrationRequests",
      "exposedModule": "./RegistrationModule",
      "ngModuleName": "RegistrationModule",
      "remoteEntry": `/modules/registration/remoteEntry.js`,
      "routePath": "registration-requests",
      "internal": true,
      "type": "module",
    },
    "users": {
      "displayName": "Users",
      "exposedModule": "./UsersModule",
      "ngModuleName": "UsersModule",
      "remoteEntry": `/modules/user/remoteEntry.js`,
      "routePath": "users",
      "internal": true,
      "type": "module",
    },
    "training-events": {
      "type": "component",
      "displayName": "Trainings",
      "exposedModule": "./training_event_route",
      "ngModuleName": "training_event_route",
      "remoteEntry": `/modules/training-events/remoteEntry.js`,
      "routePath": "training-events",
      "internal": true,
    },
    "notifications": {
      "type": "component",
      "displayName": "Notifications",
      "exposedModule": "./notifications_route",
      "ngModuleName": "notifications_route",
      "remoteEntry": `/modules/notifications/remoteEntry.js`,
      "routePath": "notifications",
      "internal": true,
    },
    "myaig-intellirisk-ui-7091": {
      "type": "module",
      "displayName": "Loss Runs",
      "exposedModule": "./LossRunsModule",
      "ngModuleName": "LossRunsModule",
      "remoteEntry": `/modules/loss-runs/remoteEntry.js`,
      "routePath": "loss-runs",
      "internal": true,
      "external": true,
      "title": "loss-runs :: myAIG"
    }
  }
}
export const EnvAppConfig = {};
